import type { MetadataRoute } from 'next';

import type { Market, MarketLocale } from '@/libs/market/market';
import { getMarketForLocale, getPathnameForMarket } from '@/libs/market/market';

export const MARKET_MANIFEST_PATHS = {
  US: '/manifest.webmanifest',
  CA: '/ca/manifest.webmanifest',
} as const satisfies Record<Market, string>;

export function getManifestPathForMarket(market: Market): string {
  return MARKET_MANIFEST_PATHS[market];
}

export function getManifestPathForLocale(locale: MarketLocale): string {
  return getManifestPathForMarket(getMarketForLocale(locale));
}

export function createStorefrontManifest(market: Market): MetadataRoute.Manifest {
  const startUrl = getPathnameForMarket('/', market);
  // Keep the canonical `/ca` start URL inside the CA scope while also covering `/ca/*`.
  const scope = market === 'CA' ? '/ca' : '/';

  return {
    id: scope,
    name: 'SweepKing',
    short_name: 'SweepKing',
    description: 'Play crypto slots, live casino and win with SweepKing.',
    start_url: startUrl,
    scope,
    display: 'standalone',
    orientation: 'portrait',
    background_color: '#24262b',
    theme_color: '#24262b',
    icons: [
      {
        src: '/pwa/icon-192.png',
        sizes: '192x192',
        type: 'image/png',
      },
      {
        src: '/pwa/icon-512.png',
        sizes: '512x512',
        type: 'image/png',
      },
      {
        src: '/pwa/icon-192-maskable.png',
        sizes: '192x192',
        type: 'image/png',
        purpose: 'maskable',
      },
      {
        src: '/pwa/icon-512-maskable.png',
        sizes: '512x512',
        type: 'image/png',
        purpose: 'maskable',
      },
    ],
    screenshots: [
      {
        src: '/pwa/banner-1.png',
        sizes: '236x420',
        type: 'image/png',
        label: 'SweepKing install preview 1',
      },
      {
        src: '/pwa/banner-2.png',
        sizes: '472x840',
        type: 'image/png',
        label: 'SweepKing install preview 2',
      },
      {
        src: '/pwa/banner-3.png',
        sizes: '472x840',
        type: 'image/png',
        label: 'SweepKing install preview 3',
      },
    ],
  };
}
